import { Link } from "react-router";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import {
    Button,
    InputField,
    SelectField,
} from "@hatch-digital-nl/abs-storybook/legacy";
import searchImage from "../../../common/images/search.svg";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
    setCurrentPage,
    setFunctionGroupFilter,
    setSearchTerm,
    setStatusFilter,
} from "../EmployeeSlice";
import { useGetEmployeesQuery } from "../../../common/api/employee";
import { useEstablishmentId } from "../../../common/utils/useEstablishmentId";
import Skeleton from "react-loading-skeleton";
import { setIsCreateEmployeeModalOpen } from "../../../modals/CreateEmployeeModal/CreateEmployeeModalSlice";
import { StatusEnum } from "../../../common/enums/StatusEnum";
import { debounce } from "../../../common/utils/debounce";
import { JSX } from "react";
import { useGetFunctionGroupsQuery } from "../../../common/api/functionGroup";
import { getFunctionGroupOptions } from "../../qualificationListPage/utils/getFunctionGroupOptions";
import { SelectFieldType } from "../../../common/types/Types";

export const EmployeeHeader = (): JSX.Element | null => {
    const dispatch = useAppDispatch();

    const {
        currentPage,
        itemsPerPage,
        searchTerm,
        statusFilter,
        functionGroupFilter,
        sort,
    } = useAppSelector((state) => state.employee);

    const { data: employees, isLoading } = useGetEmployeesQuery({
        page: currentPage,
        items_per_page: itemsPerPage,
        sort: sort.sortName,
        filter: {
            establishment_id: useEstablishmentId(),
            search: searchTerm,
            status: statusFilter ? statusFilter.value : "",
            ...(functionGroupFilter
                ? { function_group_id: Number(functionGroupFilter.value) }
                : {}),
        },
    });

    const { data: functionGroupsData } = useGetFunctionGroupsQuery({
        items_per_page: 999,
    });

    if (isLoading) {
        return (
            <Skeleton
                width={"100%"}
                count={2}
                height={"5rem"}
                borderRadius={"1.5rem"}
            />
        );
    }

    if (!employees) {
        return null;
    }

    return (
        <div className="p-employee__header">
            <div className="c-breadcrumbs">
                <span>
                    Dashboards / <Link to={RouteEnum.DASHBOARD}>LMS</Link> /{" "}
                    <Link to={RouteEnum.EMPLOYEES}>Medewerkers</Link>
                </span>
            </div>

            <div className="c-header-search">
                <div className="c-header-search__title">
                    <h2>Medewerkers ({employees?.meta?.total || 0})</h2>
                </div>

                <div className="c-header-search__search c-header-search__search--filters">
                    <SelectField
                        placeHolder={"Filter op functiegroep"}
                        options={getFunctionGroupOptions(
                            functionGroupsData?.data,
                        )}
                        onChange={(value: SelectFieldType) =>
                            dispatch(setFunctionGroupFilter(value))
                        }
                        value={functionGroupFilter}
                        isClearable={true}
                        isSearchable={false}
                    />
                    <SelectField
                        placeHolder={"Filter op status"}
                        options={[
                            {
                                label: "Actief",
                                value: StatusEnum.ACTIVE,
                                color: "#7CBF3F",
                            },
                            {
                                label: "Uitgenodigd",
                                value: StatusEnum.INVITED,
                                color: "#FFCC00",
                            },
                            {
                                label: "Uitnodiging verlopen",
                                value: StatusEnum.INVITATION_EXPIRED,
                                color: "#FFCC00",
                            },
                        ]}
                        onChange={(value: {
                            value: string;
                            label: string;
                            color: string;
                        }) => dispatch(setStatusFilter(value))}
                        value={statusFilter}
                        isSearchable={false}
                        isClearable={true}
                    />
                    <InputField
                        placeHolder={"Zoeken..."}
                        iconRight={searchImage}
                        onChange={debounce((value: string) => {
                            dispatch(setSearchTerm(value));
                            dispatch(setCurrentPage(1));
                        })}
                    />
                </div>
                <div className="c-header-search__search c-header-search__search--button">
                    <Button
                        onClick={() => {
                            dispatch(setIsCreateEmployeeModalOpen(true));
                        }}
                        variant={"primary"}
                    >
                        Medewerker toevoegen
                    </Button>
                </div>
            </div>
        </div>
    );
};
